import { ProductCategory, useGetProductCategoriesMutation } from '@services';
import { useEffect, useState } from 'react';

export const useCategoryDisplayer = () => {
    const [categories, setCategories] = useState<ProductCategory[]>([]);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const [getCategories, { data, isLoading, isError }] = useGetProductCategoriesMutation();

    const toTitleCase = (phrase: string) =>
        phrase
            .toLowerCase()
            .split(' ')
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');

    useEffect(() => {
        getCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (data) {
            setCategories(data);
        }

        if (isError) {
            setErrorMessage('Une erreur est survenue lors du chargement des catégories');
        }
    }, [data, isLoading, isError]);

    return { categories, isLoading, errorMessage, toTitleCase };
};
